import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useLayoutEffect, useState } from 'react';
import { createTechnicians, fetchBeaconsStore, fetchBeaconStoreById, SearchBeaconsStores, updateTechnician } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useDebounce } from '@/utils/DebounceHook';
import { Technicians } from './TechniciansColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { BeaconStore } from '../beaconStore/BeaconStoreColumns';
import axios from 'axios';
import SpinnerForm from '../spinnner/SpinnerForm';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />

interface ProductsDrawerProps {
    showUpdateTechnicianDrawer: boolean;
    setShowUpdateTecnicianDrawer: React.Dispatch<React.SetStateAction<boolean>>
    technicians: Technicians
    getTechnicians: any
    setTechnicianData: React.Dispatch<React.SetStateAction<Technicians | undefined>>
}
const UpdateTechnicianDrawer: React.FC<ProductsDrawerProps> = ({ showUpdateTechnicianDrawer, setShowUpdateTecnicianDrawer, technicians, getTechnicians, setTechnicianData }) => {
    const onCLose = () => {
        setShowUpdateTecnicianDrawer(false)
        setTechnicianData(undefined)
    }
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm();
    const [searchTermForBeaconStores, setSearchTermForBeaconStores] = useState('')
    const [beaconStoresToDisplay, setBeaconStoresToDisplay] = useState<any[]>([])
    const [beaconStoresOptions, setBeaconStoresOptions] = useState([])
    const [loadingForm, setLoadingForm] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()
    const [status, setStatus] = useState(technicians?.status?.toString() || "0");

    useEffect(() => {
        const setFormValues = async () => {
            const beaconStore: any = beaconStoresToDisplay.find((c: any) => c.id === technicians.beacon_store_id) ||
                await getSpecifiCBeaconStoreById(technicians.beacon_store_id)

            form.setFieldsValue({
                beacon_store_id: beaconStore ? { value: beaconStore.id, label: beaconStore.name } : undefined,
                id: technicians.id,
                first_name: technicians.first_name,
                last_name: technicians.last_name,
                email: technicians.email,
                telephone: technicians.telephone,
                status: technicians.status

            })
            setLoadingForm(false)
        };
        if (technicians) {
            setFormValues()
        }
    }, [technicians, beaconStoresToDisplay, form])

    const getSpecifiCBeaconStoreById = async (beaconStoreId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (beaconStoreId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/beaconStore/${beaconStoreId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : {}

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return {}
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(beaconStoreId)
        console.log("this is the results.............***********************88", result2)
        cleanup()
        return result2;
    }

    const getBeaconStores = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconStore', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: BeaconStore[]) => {
                if (isMounted) {
                    setBeaconStoresToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false
            controller.abort()
        }
    }

    useLayoutEffect(() => {
        getBeaconStores()
    }, [])



    const searchBeaconStoresBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beaconStore/search?query=${searchTermForBeaconStores}`, {
            signal: controller.signal
        })
            .then((response) => {
                if (isMounted) {
                    setBeaconStoresToDisplay(response.data.data);
                }
            })
            .catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForBeaconStores, 500, searchBeaconStoresBySearchTerm)

    useLayoutEffect(() => {
        const updatedBeaconStoresOptions: any = beaconStoresToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }))
        setBeaconStoresOptions(updatedBeaconStoresOptions)
    }, [beaconStoresToDisplay])

    const filterBeaconStoresOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false
    }

    const handleBeaconStoresChange = (value: any) => {
        setSearchTermForBeaconStores(value)
    }

    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }


    const onFinish = (technician: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        const extractedTechician = {
            ...technician,
            beacon_store_id: technician.beacon_store_id?.value ? technician.beacon_store_id.value : technician.beacon_store_id
        }
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.put(`/api/v1/technicians/${extractedTechician.id}`, extractedTechician, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "technician successfully updated",
                    `${technician.first_name} was updated`,
                    'topRight'
                )
            }
            getTechnicians()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    return <Drawer
        title="Update Technicians"
        width={720}
        onClose={onCLose}
        open={showUpdateTechnicianDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >

        {(loadingForm) ? (
            <div>
                <SpinnerForm />
            </div>
        ) : (
            < Form layout="vertical"
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                form={form}
                // initialValues={{
                //     beacon_store_id: technicians.beacon_store_id,
                //     id: technicians.id,
                //     first_name: technicians.first_name,
                //     last_name: technicians.last_name,
                //     email: technicians.email,
                //     telephone: technicians.telephone,
                //     status: technicians.status
                // }}

                initialValues={technicians}
                hideRequiredMark>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="beacon_store_id"
                            label="Beacon Store"

                            rules={[{ required: true, message: 'Please slect beacon store' }]}
                        >
                            <Select
                                placeholder="Please slect beacon store"
                                showSearch={false}
                                style={{ borderColor: 'black' }}
                                onSearch={handleBeaconStoresChange}
                                filterOption={filterBeaconStoresOptions}
                                disabled={true}

                            >
                                {beaconStoresOptions.map((option: any) => (
                                    <Option key={option.value} value={option.value}>{option.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="first_name"
                            label="First Name"
                            rules={[{ required: true, message: 'Please enter first name' }]}
                        >
                            <Input
                                placeholder="Please enter first name"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="last_name"
                            label="Last Name"
                            rules={[{ required: true, message: 'Please enter Last Name' }]}
                        >
                            <Input
                                placeholder="Please enter Last Name"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="email"
                            label="email"
                            rules={[{ required: true, message: 'Please enter email' }]}
                        >
                            <Input
                                placeholder="Please enter email"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="telephone"
                            label="Telephone"
                            rules={[{ required: true, message: 'Please enter telephone' }]}
                        >
                            <Input
                                type="tel"
                                placeholder="Please enter telephone"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item
                            name="status"
                            label="Status"
                            rules={[{ required: true, message: "Please select a status" }]}
                        >
                            <Select
                                placeholder="Please select status"
                                value={form.getFieldValue('status')?.toString()} // Ensure correct format
                                onChange={(value) => form.setFieldsValue({ status: value })}
                            >
                                {status === "1" ? (
                                    <Option value="0">Deactivate</Option> // Show "Deactivate" when Active (1)
                                ) : (
                                    <Option value="1">Activate</Option> // Show "Activate" when Not Active (0)
                                )}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="id"
                            label="id"
                            hidden={true}
                            rules={[{ required: true, message: 'Please enter id' }]}
                        >
                            <Input
                                placeholder="Please enter telephone"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="status"
                            label="status"
                            hidden={true}
                            rules={[{ required: true, message: 'Please enter status' }]}
                        >
                            <Input
                                placeholder="Please enter status"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    {submitting && <Spin indicator={antIcon} />}
                </Row>
            </Form>
        )}

    </Drawer >
}

export default UpdateTechnicianDrawer;


